import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import { areasTitles } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { useEffect, useState } from "react";
import { emptys, listType, versionsAccess } from "../../../data/main";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { versionsType } from "../../../data/types/versionsType";

const mainInfoTables = ["D8", "Z3", "Z14"];

export default function MainInfoBox({ params }: stdObject) {
  const routesList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.rut,
  );
  const rolsList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.rol,
  );
  const sucsList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.suc,
  );
  const areasList: any = useSelector((state: RootState) => state.data.are);
  const schedulesList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.hor,
  );
  const workshopsList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.tal,
  );
  const sevStatusList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.pag,
  );
  const formatsList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.for,
  );
  const issuesList: any = useSelector((state: RootState) => state.data.sda);
  const cPayments: Array<stdObject> = useSelector(
    (state: RootState) => state.data.ctpa,
  );
  const vPayments: Array<stdObject> = useSelector(
    (state: RootState) => state.data.vtpa,
  );
  const pricesRates: Array<stdObject> = useSelector(
    (state: RootState) => state.data.tar,
  );
  const { type, searchValues, setSearchValues, section } =
    useStructureContext();
  const [servicesList, setServicesList] = useState<stdObject>({
    type: params.type,
    list: [],
  });
  const { openMainInfo } = useMainContext();
  const cVersion = process.env.REACT_APP_VERSION as versionsType;

  const updateList = () => {
    let list: stdObject[] = [];
    if (emptys.includes(searchValues[section.id][params.code]?.value)) {
      if (mainInfoTables.includes(section.id)) {
        switch (section.id) {
          case "D8":
            list = routesList;
            break;
          case "Z3":
            list = sucsList;
            break;
          case "Z14":
            list = rolsList;
            break;
        }
        setServicesList({ type: listType[section.id].type, list });
      } else {
        const tempSearch = searchValues;
        tempSearch[section.id][params.code].value = servicesList.type;
        setSearchValues(tempSearch);
      }
    } else {
      const mainType = searchValues[section.id][params.code].value;
      switch (mainType) {
        case "ARE":
          list = areasList;
          break;
        case "HOR":
          list = schedulesList;
          break;
        case "TAL":
          list = workshopsList;
          break;
        case "PAG":
          list = sevStatusList;
          break;
        case "FOR":
          list = formatsList;
          break;
        case "SDA":
          const formatCode = searchValues[section.id].CODFOR.value;
          list =
            formatCode === ""
              ? issuesList
              : issuesList
                  .filter((e: stdObject) =>
                    e.FORMAT.includes(Number(formatCode)),
                  )
                  .sort((a: stdObject, b: stdObject) => {
                    const indexA = a.FORMAT.indexOf(Number(formatCode));
                    const indexB = b.FORMAT.indexOf(Number(formatCode));
                    if (a.GRUSDA[indexA][1] !== b.GRUSDA[indexB][1]) {
                      return a.GRUSDA[indexA][1] - b.GRUSDA[indexB][1];
                    }
                    return a.ORDSDA[indexA][1] - b.ORDSDA[indexB][1];
                  });
          break;
        case "CTPA":
          list = cPayments;
          break;
        case "VTPA":
          list = vPayments;
          break;
        case "TAR":
          list = pricesRates;
          break;
      }
      setServicesList({ type: mainType, list });
    }
  };

  useEffect(() => {
    updateList();
  }, []);

  useEffect(() => {
    updateList();
  }, [
    section.id,
    searchValues[section.id].CODFOR?.value,
    searchValues[section.id][params.code]?.value,
    routesList,
    rolsList,
    sucsList,
    areasList,
    schedulesList,
    workshopsList,
    sevStatusList,
    formatsList,
    issuesList,
    cPayments,
    vPayments,
    pricesRates,
  ]);

  const writeHeaders = () => {
    const tempHeaders = Object.keys(areasTitles).includes(servicesList.type)
      ? areasTitles[servicesList.type]
      : [];

    return servicesList.type === "ROL"
      ? tempHeaders.filter(
          (e: stdObject) =>
            ["NOMROL", "CODROL"].includes(e.code) ||
            versionsAccess[cVersion].includes(e.code),
        )
      : tempHeaders;
  };

  return params.code in searchValues[section.id] ||
    mainInfoTables.includes(section.id) ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={writeHeaders()}
        data={servicesList.list}
        onDoubleClick={(e, index) => openMainInfo(e, index, servicesList.type)}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
